import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import _ from "underscore";
import Container from "react-bootstrap/Container";

const SearchSkeletonPlaceholder = () => {
    const placeholderNr = new Array(6);

    return (
        <Container className="search-menu__inner-container">
            <div className="search-menu__left search-menu__left--placeholder">
                <div className="search-menu__left-block search-menu__left-block--placeholder">
                    <Skeleton height={"220px"} />
                </div>
                <div className="search-menu__left-block search-menu__left-block--placeholder">
                    <Skeleton height={"220px"} />
                </div>
            </div>
            <div className="search-menu__right search-menu__right--placeholder">
                <div className="search-menu__product-list">
                    {_.map(placeholderNr, (value, idx) => {
                        return (
                            <div className="search-menu__product search-menu__product--placeholder" key={idx}>
                                <Skeleton height={"220px"} className="products-carousel__card" />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Container>
    )
}

export default SearchSkeletonPlaceholder;